import _extends from "@babel/runtime/helpers/extends";
import { useListBox } from "@react-aria/listbox";
import React from "react";
import { StyledListBox } from "../internal/StyledListBox";
import { ComboBoxOption } from "./ComboBoxOption";
export function ComboBoxListBox(_ref) {
  let {
    inputWidth,
    listBoxRef,
    state,
    ...ariaListBoxProps
  } = _ref;
  const {
    listBoxProps
  } = useListBox(ariaListBoxProps, state, listBoxRef);
  return /*#__PURE__*/React.createElement(StyledListBox.Root, _extends({
    $maxHeight: "25vh",
    $minWidth: inputWidth ? `${inputWidth}px` : undefined,
    $m: "1sp 0"
  }, listBoxProps, {
    ref: listBoxRef
  }), [...state.collection].map(item => /*#__PURE__*/React.createElement(ComboBoxOption, {
    item: item,
    key: item.key,
    state: state
  })));
}
//# sourceMappingURL=ComboBoxListBox.js.map